<template>
<v-main>
  <head>
    <title>Edit products from -- {{shop.name}}</title>
    <meta name="description" content="Adjust the products for your shop">
  </head>
  <v-dialog v-model="productcreatedialog" max-width="750px" persistent>
    <v-card>
      <v-card-title style="justify-content: center">
        <span class="headline">Create a Product</span>
      </v-card-title>
      <v-card-text>
        <form @submit.prevent="CreateShopProduct">
          <v-container>
            <v-row >
              <v-col cols="12">
                <v-text-field
                  name="newproductname"
                  label="Name"
                  hint="Name of the product"
                  required
                  id="newproductname"
                  v-model="newproduct.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="newprice"
                  label="Product Price*"
                  hint="4.99, 125.00, etc. If left blank, will default to 0.00, or Free"
                  id="newprice"
                  required
                  v-model="newproduct.price"
                  prefix="$"
                  min="0"
                  step=".01"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="newunits"
                  label="Product Units*"
                  hint="How many units are you selling for the selected price? ie. per lb, per 100 seeds, per 10 kg, each etc."
                  id="newunits"
                  required
                  v-model="newproduct.price_units"
                  prefix="per"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="newinventory"
                  label="Inventory"
                  hint="How many do you have in stock? If left blank, will default to '0', which we will assume means it's out of stock."
                  id="newinventory"
                  v-model="newproduct.inventory"
                  min="0"
                  max="1000000000"
                  type="number"
                  default="0"
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="text-align: end">
                <v-btn @click="productcreatedialog = !productcreatedialog" class="ma-2">
                  Cancel
                </v-btn>
                <v-btn type="submit" :loading="productcreateloading" color="primary" class="ma-2">
                  Submit
                  <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </form>

      </v-card-text>
    </v-card>
  </v-dialog>
  <v-container v-if="isshopdataloading">
    <v-row  >
      <v-col cols="12" class="text-center">
        <v-progress-circular
          :size="100"
          :width="7"
          color="primary"
          indeterminate
        />
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else>
    <v-row>
<v-col cols="12">
  <v-card>
    <v-card-title primary-title class="layout justify-center">
      <h2>{{shop.name}}</h2>
    </v-card-title>
    <v-card-subtitle>
      <p style="text-align: center">Changes wont be saved until you hit the save button!</p>

    </v-card-subtitle>
  </v-card>
</v-col>
      <v-row>
      <v-col cols="12" sm="6">
      <v-card>
        <v-card-title class="layout justify-center">
          Products for sale at {{shop.name}}
        </v-card-title>
        <v-card-subtitle>
          <p style="text-align: center"  v-if="shop.products &&shop.products.length">You can adjust the inventory by clicking on a given value. Other edits need to be done on the <router-link :to="'/user/my-products/'">My Products</router-link> page.</p>

        </v-card-subtitle>
        <v-card-text v-if="shop.products &&shop.products.length">
          <v-container>
            <v-data-table
              :headers="shopproductheaders"
              sort-by="name"
              :items="shop.products"
              class="elevation-1"
              :loading="areproductsloading"
              :search="shopsearchvalue"
              :footer-props="{
                    itemsPerPageOptions: [10, 25, -1]}"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-btn
                    dark
                    fab
                    color="green"
                    small
                    @click="productcreatedialog = !productcreatedialog"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="shopsearchvalue"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-toolbar>
              </template>
              <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
              <template v-slot:item.remove_from_shop="{ item }">
                <v-icon
                  small
                  @click="RemoveProductFromShop(item)"
                >
                  mdi-cancel
                </v-icon>
                <span class="hidden-sm-and-up">Remove from shop</span>
              </template>
              <template v-slot:item.name="{ item }">
                <span> {{ item.name }}</span>
              </template>
              <template v-slot:item.price="{ item }">
                <span style="white-space: nowrap">$ {{ item.price.slice(0, -2) }}</span>
              </template>
              <template v-slot:item.price_units="{ item }">
                <span>per {{ item.price_units }}</span>
              </template>
              <template v-slot:item.inventory="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.inventory"
                  large
                >
                {{item.inventory}}
                  <template v-slot:input>
                    <div class="mt-4 title">Update Inventory</div>
                  </template>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.inventory"
                      label="Edit"
                      single-line
                      counter
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>
              <template slot="no-data">
                <v-alert :value="!areproductsloading" color="secondary">
                  Sorry, you have no products to show here. If you have some we don't know about, Go ahead and create one now!.
                </v-alert>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-text v-else>
          There are currently no products for sale at this location. Click the button next to one of your products to add it to this shop, or go to <router-link :to="'/user/my-products/'">My Products</router-link> to create/manage your products. Or click this green button to create one now!
          <v-btn
            dark
            fab
            color="green"
            small
            @click="productcreatedialog = !productcreatedialog"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
      <v-col cols="12" sm="6">
        <v-card>
         <v-card-title class="layout justify-center">
           All Products
         </v-card-title>
          <v-card-text v-if="products && products.length">
            <v-container>
              <v-data-table
                :headers="productheaders"
                sort-by="name"
                :items="products"
                class="elevation-1"
                :loading="areproductsloading"
                :search="searchvalue"
                :footer-props="{
                    itemsPerPageOptions: [10, 25, -1]}"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchvalue"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                </template>
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template v-slot:item.add_to_shop="{ item }">
                  <v-icon
                    small
                    @click="MoveProductToShop(item)"
                    class="hidden-xs-only"
                  >
                    mdi-arrow-left-thick
                  </v-icon>
                  <v-icon
                    small
                    @click="MoveProductToShop(item)"
                    class="hidden-sm-and-up"
                  >
                    mdi-plus
                  </v-icon>
                  <span class="hidden-sm-and-up">Add to shop</span>
                </template>
                <template v-slot:item.price="{ item }">
                  <span style="white-space: nowrap">$ {{ item.price.slice(0, -2) }}</span>
                </template>
                <template v-slot:item.price_units="{ item }">
                  <span>per {{ item.price_units }}</span>
                </template>
                <template v-slot:item.inventory="{ item }">
                  {{item.inventory}}
                </template>
                <template slot="no-data">
                  <v-alert :value="!areproductsloading" color="secondary">
                    Sorry, you have no products to show here. If you have some we don't know about, Go ahead and create one now!.
                  </v-alert>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
          <v-card-text v-else>
            You have no products, or no other products than those currently listed at this shop, that we know about. Head over to <router-link :to="'/user/my-products/'">My Products</router-link> to create a product.
          </v-card-text>
        </v-card>
        <v-fab-transition>
          <v-btn
            dark
            fab
            bottom
            right
            fixed
            color="green"
            @click="CompleteShopProductUpdate"
          >
            <v-icon>mdi-floppy</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-col>
        </v-row>
    </v-row>
  </v-container>
</v-main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ShopProductEdit',
  data: () => ({

    shop: [],
    shop_images: [],
    products: [],
    productstoremove: [],
    errors: [],
    is_something_loading: false,
    areproductsloading: false,
    isshopdataloading: false,
    usersdefaults: [],
    usersdefaultsfetched: false,

    productheaders: [
      {
        value: 'add_to_shop',
        sortable: false,
      },
      {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Price',
        value: 'price',
        sortable: true,
      },
      {
        text: 'Units',
        value: 'price_units',
        sortable: true,
      },
      {
        text: 'Inventory',
        value: 'inventory',
        sortable: true,
      },
    ],
    shopproductheaders: [
      {
        value: 'remove_from_shop',
        sortable: false,
      },
      {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Price',
        value: 'price',
        sortable: true,
      },
      {
        text: 'Units',
        value: 'price_units',
        sortable: true,
      },
      {
        text: 'Inventory (at this location)',
        value: 'inventory',
        sortable: true,
      },
    ],
    searchvalue: '',
    shopsearchvalue: '',
    newproduct: {
      name: '',
      price: 0.00,
      price_units: '',
      inventory: '',
    },
    productcreateloading: false,
    productcreatedialog: false,

  }),

  methods: {
    FetchShopInfo() {
      const shopSlug = this.$route.params.shopslug;
      this.isshopdataloading = true;
      this.shop = [];
      const authheader = `Token ${this.$store.getters.token}`;
      axios.get(`protected/shops/${shopSlug}/`, {
        headers: {
          Authorization: authheader,
        },
      })
        .then((response) => {
          this.shop = response.data;
          this.isshopdataloading = false;
        })
        .then(() => {
          this.GetThisUsersProducts();
        })
        .then(() => axios.get(`/image/by/shop/${this.shop.id}/`))
        .then((response) => {
          this.shop_images = response.data.results;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    GetThisUsersProducts() {
      this.areproductsloading = true;
      this.products = [];
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get('basics/table/product/by/vendor/',

        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.products = this.FilterShopProducts(response.data);
        })
        .then(() => {
          this.areproductsloading = false;
        });
    },
    MoveProductToShop(item) {
      // eslint-disable-next-line no-param-reassign
      item.new = true;
      this.shop.products.push(item);
      this.products = this.products.filter(entry => entry !== item);
      this.productstoremove = this.productstoremove.filter(entry => entry !== item);
    },
    RemoveProductFromShop(item) {
      // eslint-disable-next-line no-param-reassign
      this.shop.products = this.shop.products.filter(entry => entry !== item);
      this.products.push(item);
      if (!item.new) {
        this.productstoremove.push(item);
      }
    },
    ShopUpdate() {
      const authheader = `Token ${this.$store.getters.token}`;
      const shopslug = this.shop.slug;
      //
      this.shop.products.forEach((product) => {
        // Create new ShopProducts
        if (product.new) {
          // eslint-disable-next-line no-param-reassign
          // eslint-disable-next-line no-param-reassign
          axios.post(`forms/products/shop_products/create/${shopslug}/`, {
            product: product.id,
            inventory: product.inventory,
          },
          {
            headers: {
              Authorization: authheader,
            },
          });
        } else if (!product.new) {
          axios.patch(`forms/products/shop_products/update/${product.id}/`, {
            inventory: product.inventory,
          },
          {
            headers: {
              Authorization: authheader,
            },
          });
        }
      })
    },
    SubmitProductRemoval() {
      const authheader = `Token ${this.$store.getters.token}`;
      this.productstoremove.forEach((product) => {
        axios.patch(`forms/products/shop_products/update/${product.id}/`, {
          is_active: false,
        },
        {
          headers: {
            Authorization: authheader,
          },
        });
      });
    },
    CompleteShopProductUpdate() {
      this.SubmitProductRemoval();
      this.ShopUpdate();
      this.$router.push('/user/shops/');
    },
    // Remove the products available at this shop from the 'all products' section
    FilterShopProducts(array) {
      const shopproducts = this.shop.products;
      return array.filter(({ id: id1 }) => !shopproducts.some(({ product: id2 }) => id2 === id1));
    },
    removeEmptyStrings(obj) {
      const newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') { newObj[prop] = obj[prop]; }
      });
      return newObj;
    },
    GetUserSavedDefaults() {
      const authheader = `Token ${this.$store.getters.token}`;

      if (!this.usersdefaultsfetched) {
        return axios.get('profile/saveddefaults/',
          {
            headers: {
              Authorization: authheader,
            },
          })
          .then((response) => {
            this.usersdefaults = response.data;
            this.usersdefaultsfetched = true;
          });
      }
      return Promise.resolve();
    },
    GetProductData() {
      return this.removeEmptyStrings({
        name: this.newproduct.name,
        price: this.newproduct.price,
        price_units: this.newproduct.price_units,
        inventory: this.newproduct.inventory,
        shipping_location: this.usersdefaults.default_shipping_location,
      });
    },
    CreateShopProduct() {
      this.productcreateloading = true;
      const shopslug = this.shop.slug;
      return this.GetUserSavedDefaults()
        .then(() => {
          const authheader = `Token ${this.$store.getters.token}`;
          return axios.post('forms/create/product/', this.GetProductData(),
            {
              headers: {
                Authorization: authheader,
              },
            })
            .then((response) => {
              this.newproduct.price = response.data.price;
              this.$parent.$emit('alert-emitted', {
                alert_icon: 'mdi-check-circle',
                alert_color: 'success',
                alert_message: `Your product " ${response.data.name} " was successfully created! You may need to refresh the page to see it.`,
                alert_model: true,
              });
              return axios.post(`forms/products/shop_products/create/${shopslug}/`, {
                product: response.data.id,
                inventory: response.data.inventory,
              },
              {
                headers: {
                  Authorization: authheader,
                },
              });
            })
            .then((response) => {
              this.shop.products.push({
                id: response.data.product, inventory: response.data.inventory, name: this.newproduct.name, price: this.newproduct.price, price_units: this.newproduct.price_units,
              });
            })
            .then(() => {
              this.productcreateloading = false;
              this.productcreatedialog = false;
              this.newproduct = {
                name: '',
                price: 0.00,
                price_units: '',
                inventory: '',
              };
            })
            .catch((e) => {
              this.$parent.$emit('alert-emitted', {
                alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something broke. Sorry :( ', alert_model: true,
              });
              console.log(e);
            });
        });
    },
  },
  created() {
    this.FetchShopInfo();
  },

};
</script>

<style scoped>

</style>
